import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getAll() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/users/', HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getAllForSelect(query) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/users/for-select?query=${query}`, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getAllRols() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			return axios
				.get('/users/roles', HEADER)
				.then((response) => response.data)
				.catch((error) => error.response.data);
		}
	},

	async saveRol(obj) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			return axios
				.patch(`/users/update-role/${obj.id}`, obj, HEADER)
				.then((response) => response.data)
				.catch((error) => error.response.data);
		}
	},

	async saveRolAsync(user) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.patch(`/users/update-role/${user._id}`, user, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async show(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			return axios
				.get('/users/' + id, HEADER)
				.then((response) => response.data)
				.catch((error) => error.response.data);
		}
	},

	async getUserByIdAsync(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/users/${id}`, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async edit(obj) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			return axios
				.patch('/users/' + obj._id, obj, HEADER)
				.then((response) => response.data)
				.catch((error) => error.response.data);
		}
	},
	async save(obj) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			return axios
				.post('/users/', obj, HEADER)
				.then((response) => response.data)
				.catch((error) => error.response.data);
		}
	},

	async saveAsync(obj) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.post('/users/', obj, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async editAsync(obj) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.patch(`/users/${obj._id}`, obj, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async delete(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			return axios
				.delete('/users/' + id, HEADER)
				.then((response) => response.data)
				.catch((error) => error.response.data);
		}
	},

	postUser(firstname, lastName, email, password) {
		return axios
			.post('/users', { firstname, lastName, email, password })
			.then((res) => res.data);
	},

	async postUpdateFirstPassword(email, newPassword) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios
				.post('/users/update-first-password', { email, newPassword }, HEADER)
				.then((res) => res.data);
	},

	async postUpdatePassword(userId, newPassword) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios
				.post('/users/update-password', { userId, newPassword }, HEADER)
				.then((res) => res.data);
	},

	async postCheckPassword(password) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios
				.post('/users/check-password', { password }, HEADER)
				.then((res) => res.data);
	}
};
